import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatSort, MatPaginator } from '@angular/material';

import { TABLES_CONFIG } from '@asambleas-env/environment';
import { Church } from '@asambleas-models/church.model';
import { ChurchService } from '@asambleas-services/church/church.service';
import { GeneralService } from '@asambleas-services/general/general.service';

@Component({
    selector: 'app-lista-iglesias',
    templateUrl: './lista-iglesias.component.html',
    styleUrls: ['./lista-iglesias.component.css']
})
export class ListaIglesiasComponent implements OnInit {

    ROWS = TABLES_CONFIG.ROW_NUMBER

    // Defines if all the needed resources has load
    resourcesHasLoaded: boolean = false;
    isAuthorized = true;

    allChurches: Church[] = [];

    displayedColumns = ['churchName', 'pastor', 'district', 'sectional', 'city', 'id'];
    dataSource = new MatTableDataSource();

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private _churchService: ChurchService,
        private generalService: GeneralService
    ) {
        this.loadChurches();
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    loadChurches() {
        this._churchService.getChurches()
            .subscribe((data: Church[]) => {
                this.allChurches = this._churchService.sortIglesiasByNombre(data);
                this.allChurches.forEach(church => {
                    this.generalService.churches[church.id] = church;
                });
                this.dataSource = new MatTableDataSource(this.allChurches);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.resourcesHasLoaded = true;
            },
                (error) => {
                    console.log('error', error);
                    this.isAuthorized = false;
                    this.resourcesHasLoaded = true;
                });
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/iglesias/lista-iglesias/lista-iglesias.component.ts